import { addFullMarkCommand, removeFullMarkCommand, getMarkAttrs, isCustomMarkAllowed, setActiveTool } from "../../../commands/custom-commands";
import { customSchema } from "../../../schemas/custom-schema";

export default class LinkTool {
  constructor(editorView, containerElement) {
    this.view = editorView;
    this.buildContainer();
    this.buildDialog();
    this.bindActions();
    containerElement.appendChild(this.containerElement);
    this.update(editorView);
  }

  buildContainer() {
    this.containerElement = document.createElement("div");
    this.containerElement.className = "editor-button-container";
    this.buttonElement = document.createElement("button");
    this.buttonElement.setAttribute("type", "button");
    this.buttonElement.className = "editor-toolbar-button";
    this.buttonElement.dataset.action = "link";
    this.buttonElement.setAttribute("aria-expanded", "false");
    this.buttonElement.title =" Liga";
    this.buttonElement.style.anchorName = "--link-anchor";
    const iconSpan = document.createElement("span"),
      labelSpan = document.createElement("span");
    iconSpan.textContent = "Liga";
    labelSpan.className = "oculto-visual";
    labelSpan.textContent = "Liga";
    this.buttonElement.appendChild(iconSpan);
    this.buttonElement.appendChild(labelSpan);
    this.containerElement.appendChild(this.buttonElement);
  }

  buildDialog() {
    const targetInputContainer = document.createElement("div"),
      targetLabel = document.createElement("label"),
      buttonsContainer = document.createElement("div");

    this.dialogElement = document.createElement("div");
    this.dialogElement.className = "editor-dialog";
    this.dialogElement.style.positionAnchor = "--link-anchor";
    this.urlInput = document.createElement("input");
    this.urlInput.setAttribute("placeholder", "URL");
    this.urlInput.className = "editor-input";
    //this.urlInput.required = true;
    this.urlInput.type = "text";

    this.focusCheckbox = this.labelClickCallback();
    targetInputContainer.className = "editor-checkbox-container";
    this.targetInput = document.createElement("input");
    this.targetInput.type = "checkbox";
    this.targetInput.className = "editor-checkbox";
    targetLabel.textContent = "Desplegar en pestaña aparte";
    targetLabel.className = "editor-checkbox-label";
    targetLabel.addEventListener("click", this.focusCheckbox);
    targetInputContainer.appendChild(this.targetInput);
    targetInputContainer.appendChild(targetLabel);

    this.submitButton = document.createElement("button");
    this.submitButton.type = "button";
    this.submitButton.className = "editor-button";
    this.submitButton.textContent = "Agregar";

    this.removeButton = document.createElement("button");
    this.removeButton.type = "button";
    this.removeButton.className = "editor-button";
    this.removeButton.textContent = "Remover";

    buttonsContainer.className = "editor-buttons-container";
    buttonsContainer.appendChild(this.submitButton);
    buttonsContainer.appendChild(this.removeButton);

    this.dialogElement.appendChild(this.urlInput);
    this.dialogElement.appendChild(targetInputContainer);
    this.dialogElement.appendChild(buttonsContainer);

    this.containerElement.appendChild(this.dialogElement);
  }

  bindActions() {
    this.buttonAction = this.buttonClickCallback();
    this.removeAction = this.removeButtonClickCallback();
    this.submitAction = this.submitButtonClickCallback();
    this.changeAction = this.inputChangeCallback();
    this.buttonElement.addEventListener("click", this.buttonAction);
    this.submitButton.addEventListener("click", this.submitAction);
    this.removeButton.addEventListener("click", this.removeAction);
    this.urlInput.addEventListener("input", this.changeAction);
  }

  update(view) {
    const markAttrs = getMarkAttrs(view.state, customSchema.marks.link),
      isEnabled = addFullMarkCommand(
        customSchema.marks.link,
        { href: "" },
        true,
        [/*customSchema.marks.backgroundColor, customSchema.marks.fontColor, customSchema.marks.fontSize*/],
        [customSchema.nodes.ghost, customSchema.nodes.note]
      )(this.view.state, null);
    if(markAttrs) { 
      this.urlInput.value = markAttrs.href;
      this.targetInput.checked = !!markAttrs.target;
      this.buttonElement.setAttribute("aria-pressed", "true");
      this.removeButton.removeAttribute("disabled");
    } else {
      this.urlInput.value = null;
      this.targetInput.checked = false;
      this.buttonElement.setAttribute("aria-pressed", "false");
      this.removeButton.setAttribute("disabled", "");
    }

    this.buttonElement.disabled = !isEnabled;
    this.changeAction();
    this.view = view;
  }

  destroy() {
    this.buttonElement.removeEventListener("click", this.buttonAction);
    this.removeButton.removeEventListener("click", this.removeAction);
    this.submitButton.removeEventListener("submit", this.submitAction);
    this.urlInput.removeEventListener("input", this.changeAction);
    this.containerElement.remove();
    this.containerElement = null;
    this.buttonElement = null;
    this.urlInput = null;
    this.targetInput = null;
    this.submitButton = null;
    this.removeButton = null;
    this.dialogElement = null;
    this.buttonAction = null;
    this.submitAction = null;
    this.removeAction = null;
    this.changeAction = null;
    this.focusCheckbox = null;
  }

  labelClickCallback() {
    return () => {
      if(!this.targetInput.disabled) {
        this.targetInput.checked = !this.targetInput.checked;
      }
    }
  }

  removeButtonClickCallback() {
    return () => {
      this.urlInput.value = null;
      this.targetInput.checked = false;
      removeFullMarkCommand(customSchema.marks.link)(this.view.state, this.view.dispatch);
      setActiveTool(null)(this.view.state, this.view.dispatch);
      this.view.focus();
    }
  }

  buttonClickCallback() {
    return () => {
      setActiveTool(this.buttonElement)(this.view.state, this.view.dispatch);
    }
  }

  submitButtonClickCallback() {
    return (event) => {
      event.preventDefault();
      const { value: href } = this.urlInput,
        { checked, disabled } = this.targetInput;

      if(href == null || href.trim() === "" || !this.evaluateUrl(href.trim())) {
        alert("No se puede insertar una liga inválida. Verifique e intente de nuevo.");

        return false;
      }

      if(!disabled && checked && href.substring(0, 1) !== "#") {
        addFullMarkCommand(
          customSchema.marks.link,
          { href: href.trim(), target: "_blank" },
          true,
          [customSchema.marks.backgroundColor, customSchema.marks.fontColor, customSchema.marks.fontSize],
          [customSchema.nodes.ghost, customSchema.nodes.note]
        )(this.view.state, this.view.dispatch);
      } else {
        addFullMarkCommand(
          customSchema.marks.link,
          { href: href.trim() },
          true,
          [/*customSchema.marks.backgroundColor, customSchema.marks.fontColor, customSchema.marks.fontSize*/],
          [customSchema.nodes.ghost, customSchema.nodes.note]
        )(this.view.state, this.view.dispatch);
      }
      setActiveTool(null)(this.view.state, this.view.dispatch);
      this.view.focus();
    }
  }

  inputChangeCallback() {
    return () => {
      const { value } = this.urlInput,
        isValid = this.evaluateUrl(value);
      this.submitButton.disabled = !isValid;
      this.targetInput.disabled = !this.enableTarget(value); 
    }
  }

  enableTarget(url) {
    try {
      const newUrl = new URL(url);

      return true;
    } catch(e) {
      return url.substring(0, 1) === "/";
    }
  }

  evaluateUrl(url) {
    try {
      const newUrl = new URL(url);

      return true;
    } catch(e) {
      return /^#[a-zA-Z][a-zA-Z0-9_-]*$/.test(url) || url.substring(0, 1) === "/";
    }
  }
}
